import { Image } from "@chakra-ui/react";

export default function ImageComponent({ src, alt, height, fit, radius }) {
  return (
    <Image
      boxSize="100%"
      height={height}
      objectFit={fit ? fit : "cover"}
      src={src}
      alt={alt}
      borderRadius={radius}
    />
  );
}
